
define('text!modules/campaign/chart/winLoss/templates/ttipCampaignSummaryFunnel.html',[],function () { return '<label>\n  <div>\n    <span>{{metric}}</span>: <span style="font-weight: bold;">{{value}}</span>\n  </div>\n</label>\n';});

